import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import * as PIXI from "pixi.js";
import { ASSETS } from "../../assets";

export const loadAssets = createAsyncThunk("assets/loadAssets", async () => {
  // Load textures from the ASSETS object
  for (const asset of ASSETS.textures) {
    // Check if the texture is already cached
    if (!PIXI.Assets.cache.has(asset.url)) {
      // Load the texture if not cached
      await PIXI.Assets.load(asset.url);
    }
  }

  // Preload Spine animations from the ASSETS object
  for (const animation of ASSETS.spineAnimations) {
    // Check if the animation is already cached
    if (!PIXI.Assets.cache.has(animation.json)) {
      // Load the animation if not cached
      await PIXI.Assets.load(animation.json);
    }
  }

  // Load bitmap fonts from the ASSETS object
  for (const font of ASSETS.bitmapFonts) {
    // Check if the font is already cached
    if (!PIXI.Assets.cache.has(font.json)) {
      // Load the font if not cached
      await PIXI.Assets.load(font.json);
    }
  }

  // Return true to indicate successful loading
  return true;
});

const assetsSlice = createSlice({
  name: "assets",
  initialState: {
    status: "idle",
    assetsLoaded: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(loadAssets.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(loadAssets.fulfilled, (state) => {
        state.status = "succeeded";
        state.assetsLoaded = true;
      })
      .addCase(loadAssets.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload || "An unknown error occurred.";
        state.assetsLoaded = false;
      });
  },
});

export default assetsSlice.reducer;
